import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/font-awesome': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M397.8 32H50.2C22.7 32 0 54.7 0 82.2V429.8C0 457.3 22.7 480 50.2 480H397.8C425.3 480 448 457.3 448 429.8V82.2C448 54.7 425.3 32 397.8 32zM352.4 316.3C352.4 320.5 348.8 322.3 344.6 324.1 327.9 331.3 310 337.8 290.8 337.8 263.9 337.8 251.4 321.1 219.1 321.1 195.8 321.1 171.3 329.5 151.6 338.4 150.4 339 149.2 339 148 339.6V385C148 386.8 148 388.6 147.4 389.8V391C145 399.4 137.2 405.3 128.3 405.3 117 405.3 108 396.3 108 385V166.4C100.2 160.4 94.9 150.9 94.9 140.1 94.9 121.6 109.8 106.6 128.4 106.6 146.9 106.6 161.9 121.5 161.9 140.1 161.9 150.9 157.1 160.4 148.8 166.4V184.9C150.6 184.3 152.4 183.7 154.2 182.5 172.7 174.7 194.8 168.2 215.7 168.2 238.4 168.2 256.3 174.2 276.6 181.9 280.8 183.7 285 184.3 289.7 184.3 312.4 184.3 337.5 168.2 343.5 168.2 348.3 168.2 352.5 171.8 352.5 176V316.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/font-awesome.js
// module id = mGib
// module chunks = 144